export const copy = (obj) => !obj ? null : JSON.parse(JSON.stringify(obj));
